<template>
    <Incremental
        :quantity-text="quantityText"
        :in-group="inGroup"
        :item-description="itemDescription"
        :item-pricing="itemPricing"
        :yearly-price="yearlyPricing"
        :subtract-disabled="subtractDisabled"
        :learn-more="item.metadata.learnMore"
        :item-type="attachmentType"
        :add-disabled="addDisabled"
        @subtract-item="subtract"
        @increment-item="add"
        v-if="shouldShow"
    />
</template>

<script>
import Incremental from '@/BuyNow/Components/AttachmentCards/Incremental.vue';
import { pluralize } from '@/Util/helpers.js';

export default {
    data() {
        return {
            selectedQuantity: 0,
        };
    },
    components: {
        Incremental
    },
    mounted() {
        if (this.lineItems.find(item => item.itemId === this.item.itemId)) {
            this.selectedQuantity = this.lineItems.find(item => item.itemId === this.item.itemId).quantity;
        }
    },
    props: {
        inGroup: {
            type: Boolean,
            default: false,
        },
        parentAdded: {
            type: Boolean,
            default: false,
        },
        item: Object,
        attachmentType: String
    },
    methods: {
        async add() {
            if (!this.addDisabled) {
                this.selectedQuantity += 1;
                if (this.lineItems.find(item => item.itemId === this.item.itemId)) {
                    this.$store.commit('updateAttachment', { itemId: this.item.itemId, quantity: this.selectedQuantity });
                } else {
                    this.$store.commit('addAttachment', { itemId: this.item.itemId, quantity: this.selectedQuantity });
                }
                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        },
        async subtract() {
            if (this.lineItems.find(item => item.itemId === this.item.itemId)) {
                this.selectedQuantity -= 1;
                if (this.selectedQuantity <= 0) {
                    this.$store.commit('removeAttachment', this.item.itemId);
                } else {
                    this.$store.commit('updateAttachment', { itemId: this.item.itemId, quantity: this.selectedQuantity });
                }
                if (this.$store.getters.hasFetchedEstimate && this.$store.getters.shouldFetchEstimate) {
                    await this.$store.dispatch('fetchEstimate');
                }
            }
        },
    },
    created() {
    },
    computed: {
        shouldShow() {
            if (!!this.item.metadata.group && !this.item.metadata.group.parent) {
                return this.parentAdded;
            }
            return true;
        },
        addDisabled() {
            if (this.$store.getters.isSoftLoading) {
                return true;
            }
            return !!this.pricingObject.tiers[0].maxUnits && !this.selectedQuantity >= this.pricingObject.tiers[0].maxUnits;
        },
        subtractDisabled() {
            if (this.$store.getters.isSoftLoading) {
                return true;
            }
            return this.selectedQuantity <= 0;
        },
        lineItems() {
            return [
                ...this.$store.state.cartInfo.selectedAddons,
                ...this.$store.state.cartInfo.selectedCharges,
            ];
        },
        selectedCharge() {
            return this.$store.state.cartInfo.selectedCharges.find(item => {
                return item.itemId == this.item.itemId;
            });
        },
        selectedAddon() {
            return this.$store.state.cartInfo.selectedAddons.find(item => {
                return item.itemId == this.item.itemId;
            });
        },
        selectedPricing() {
            if (!this.lineItems.find(item => item.itemId === this.item.itemId)) {
                return 0;
            } else {
                return this.pricingObject.tiers[0].unitPrice * this.selectedQuantity;
            }
        },
        pricingObject() {
            let found;
            if (this.item.pricing.length > 1) {
                found = this.item.pricing.find((price) => {
                    return price.billingPeriodUnit === this.$store.getters.cartInfo.billingPeriod;
                });
            } else {
                found = this.item.pricing[0];
            }
            return found;
        },
        quantityText() {
            // Additional message bundle edge case
            if (this.item.itemId.toLowerCase().includes('500-additional-message-bundle')) {
                return `${(this.quantity * 500).toLocaleString()} ${pluralize(this.unit, (this.quantity * 500))}`;
            }
            // End additional message bundle edge case

            return `${this.quantity.toLocaleString()} ${pluralize(this.unit, this.quantity)}`;
        },
        quantity() {
            if (!this.lineItems.find(item => item.itemId === this.item.itemId)) {
                return 0;
            } else {
                let tier = this.lineItems.find(item => item.itemId === this.item.itemId);
                return tier.quantity;
            }
        },
        unit() {
            let unit = this.item.metadata.unitTitle || this.item.metadata.unitOfMeasure || this.item.unit || this.item.metadata.title || this.item.name;
            if (unit && unit.includes('|')) {
                unit = unit.split('|');
                return unit[0];
            }
            return unit;
        },
        itemPricing() {
            if (this.attachmentType === 'charge') {
                return this.selectedPricing / 100;
            }else if (this.$store.getters.isYearly) {
                return Math.round(((this.selectedPricing / 100) / 12) * 100) / 100
            } else {
                return this.selectedPricing / 100;
            }
        },
        yearlyPricing() {
            return this.selectedPricing / 100;
        },
        itemName() {
            return this.item.metadata.title || this.item.name;
        },
        itemDescription() {
            return this.item.metadata.description || this.item.description;
        },
    },
    watch: {
    }
};
</script>

<style lang="postcss" scoped>
</style>
